import { Modal } from '@mantine/core';
import type { ReactNode } from 'react';
import { Button } from './Button';
import { Icon } from './Icon';

type Props = {
  opened: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  /** Ce que l'action va faire, en clair. */
  children: ReactNode;
  /** Ce qui ne se défera pas, le cas échéant. */
  warning?: ReactNode;
  confirmLabel: string;
  danger?: boolean;
  loading?: boolean;
};

/**
 * Confirmation générique pour les actions qui engagent quelque chose.
 *
 * La règle appliquée dans l'application : une action qui ÉCRIT sur le serveur
 * — envoi de fichier, ingestion, arrêt d'un traitement en cours, révocation —
 * s'annonce avant de partir. Une action qui ne fait que lire ou simuler, non :
 * multiplier les fenêtres sur des gestes sans conséquence apprend à cliquer
 * sans lire, et affaiblit celles qui protègent réellement quelque chose.
 */
export function ConfirmModal({
  opened,
  onClose,
  onConfirm,
  title,
  children,
  warning,
  confirmLabel,
  danger,
  loading,
}: Props) {
  return (
    <Modal opened={opened} onClose={onClose} size={520} centered title={title}>
      <div style={{ fontSize: 13.5, color: 'var(--ink-2)', lineHeight: 1.5 }}>{children}</div>

      {warning && (
        <div className="confirm-warn" style={{ marginTop: 14 }}>
          <Icon name="alert" size={16} />
          <div>{warning}</div>
        </div>
      )}

      <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end', marginTop: 18 }}>
        <Button variant="ghost" onClick={onClose} disabled={loading}>
          Annuler
        </Button>
        <Button
          variant={danger ? 'alert' : 'primary'}
          icon={danger ? 'alert' : 'check'}
          onClick={onConfirm}
          loading={loading}
        >
          {confirmLabel}
        </Button>
      </div>
    </Modal>
  );
}
